import React from 'react'
import UploadFile from '@/components/UploadFile'

interface DocumentUploadProps {
  label: string
  value: File | null
  imageUrl: string | null
  fieldKey: string
  onFileChange: (file: File | null) => void
  onUploadSuccess: (fileUrl: string, file: File) => void
  onUploadError: (error: string) => void
  onRemove: () => void
  placeholder?: string
  className?: string
}

const DocumentUpload: React.FC<DocumentUploadProps> = ({
  label,
  value,
  imageUrl,
  fieldKey: _fieldKey,
  onFileChange,
  onUploadSuccess,
  onUploadError,
  onRemove,
  placeholder,
  className
}) => {
  return (
    <div className={`mb-8 ${className}`}>
      <div className="block text-3 font-medium text-[#1A1A1A]/60 mb-3">
        {label}
      </div>
      <div className="bg-#F5F5F5 h-41 rounded-2.5 flex justify-center items-center">
        <UploadFile
          value={value}
          onChange={(file) => {
            onFileChange(file)
            if (!file) {
              onRemove()
            }
          }}
          maxSize={10} // 10MB
          autoUpload={true}
          onUploadSuccess={onUploadSuccess}
          onUploadError={onUploadError}
          className="w-full h-full"
        >
          {imageUrl ? (
            <img 
              src={imageUrl} 
              alt={placeholder} 
              className="w-full h-full object-cover rounded-2.5" 
            />
          ) : (
            <div className='w-full h-full flex justify-center items-center'>
              <img src="/icon/camera.svg" alt={placeholder} />
            </div>
          )}
        </UploadFile>
      </div>
    </div>
  )
}

export default DocumentUpload